
import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent  {

  menuData: {
    CompanyName: string;
    IdCompany: number;
    IdApp: number;
    IS_DEFAULT: number;
    Logo: string;
    AppName: string;
    Dashboard: string;
    detail: {
      Menu: {
        id: string;
        label: string;
        link: string;
        icon: string | null;
      };
    }[];
  } | null = null;
  

  constructor(
) {
  }

  ngOnInit(): void {
    const storedMenuData = localStorage.getItem('Menu');
  if (storedMenuData) {
    this.menuData = JSON.parse(storedMenuData);
  } else {
    // Manejar el caso en que los datos no estén disponibles en el localStorage
    console.error('No se encontraron datos en el localStorage para la clave "Menu".');
  }
  }

  onMenuClick(menu: any) {
    localStorage.setItem('IdMenu', menu.id);
    localStorage.setItem('franco', menu.id);
    console.log("menu.link", menu.link);
    // window.location.href = menu.link;
  }
}
